import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { useIntl } from '@leagueplatform/locales';
import type { HeaderNavLink } from '@leagueplatform/solutions-foundation';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';

export const useNavLinksList = () => {
  const { formatMessage } = useIntl();
  const navLinksList: HeaderNavLink[] = [
    {
      to: APP_MANAGED_ROUTES.HOME,
      label: formatMessage({ id: 'STR_HOME' }),
      icon: 'descriptiveHome',
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.benefits),
      label: formatMessage({ id: 'STR_BENEFITS' }),
      icon: 'capabilityWallet',
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.careDiscovery),
      label: formatMessage({ id: 'STR_GET_CARE' }),
      icon: 'descriptiveHeart',
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
      label: formatMessage({ id: 'STR_JOURNEY' }),
      icon: 'capabilityJourney',
    },
    {
      to: APP_MANAGED_ROUTES.SUPPORT,
      label: formatMessage({ id: 'STR_SUPPORT' }),
      icon: 'descriptiveSupportQuestionChat',
    },
  ];
  return { navLinks: navLinksList };
};
